import { render, staticRenderFns } from "./recordingDetails.vue?vue&type=template&id=022d54cd&scoped=true&"
import script from "./recordingDetails.vue?vue&type=script&lang=js&"
export * from "./recordingDetails.vue?vue&type=script&lang=js&"
import style0 from "./recordingDetails.vue?vue&type=style&index=0&id=022d54cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d54cd",
  null
  
)

export default component.exports